import { useEffect, useState } from "react";
import { fetchFinanceCodes } from "../services/financeCodes";

export default function useFinanceCodes(instanceUniqueId, scope = "all") {
  const [financeCodes, setFinanceCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!instanceUniqueId) {
      setFinanceCodes([]);
      return undefined;
    }

    setLoading(true);
    setError("");
    fetchFinanceCodes(instanceUniqueId, scope)
      .then((rows) => {
        if (!active) return;
        setFinanceCodes(Array.isArray(rows) ? rows : []);
      })
      .catch((err) => {
        if (!active) return;
        setError(err?.response?.data?.message || err?.message || "Failed to load finance codes.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [instanceUniqueId, scope]);

  return { financeCodes, loading, error };
}
